// extracted by mini-css-extract-plugin
export var body = "style-mod--body--28740";
export var button = "style-mod--button--8debb";
export var links = "style-mod--links--fb226";
export var loginInfo = "style-mod--login-info--f3e52";
export var message = "style-mod--message--3d53d";
export var opened = "style-mod--opened--632fb";
export var sidePanel = "style-mod--side-panel--1024c";
export var subtitle = "style-mod--subtitle--79757";